/** 判斷是否為IOS裝置 */
function isIOS(): boolean {
  const u = navigator.userAgent;
  const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
  return isiOS;
}

const bol: boolean = isIOS();

export default bol;
